/**
 * ProductListContainer
 * --
 */
import React from 'react';
import ProductList from 'routes/admin.routes/admin.products/ProductList';
import { useUserStack } from 'store';

const ProductListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <ProductList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default ProductListContainer;
